module.exports = __webpack_public_path__ + "static/media/Unterschrift Dick.68bb59ee.svg";